import React from 'react';
import { ComingSoon } from '../common/ComingSoon';

type Props = {};

export const FullPageComingSoon: React.FC<Props> = ({}) => {
    return (
        <div className={`full-page-coming-soon`}>
            <ComingSoon />
        </div>
    );
};
